var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoHandbag = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "15px",
    viewBox: "0 0 20 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C7137AFD-790E-4570-8A6A-8E449587E48D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.78160922,5.83333333 L6.78160922,3.33333333 L13.5632184,3.33333333 L13.5632184,5.83333333 L17.6489718,5.83333333 L19.4806647,14.8365699 L19.4971265,15 C19.4971265,16.2932525 18.2703491,17.4783333 16.954023,17.4783333 L3.39080461,17.4783333 C2.07447852,17.4783333 0.847701152,16.2932525 0.847701152,15 L0.864162936,14.8365699 L2.6958559,5.83333333 L6.78160922,5.83333333 Z M8.47701152,5.83333333 L11.8678161,5.83333333 L11.8678161,5 L8.47701152,5 L8.47701152,5.83333333 Z M11.8678161,10.8333333 L11.8678161,12.5 L8.47701152,12.5 L8.47701152,10.8333333 L3.40759237,10.8333333 L2.54730588,15.06186 C2.59426193,15.4144523 3.02579061,15.8116666 3.39080458,15.8116666 L16.9540235,15.8116666 C17.3190374,15.8116666 17.7505661,15.4144523 17.7975222,15.06186 L16.9372357,10.8333333 L11.8678161,10.8333333 Z M3.74667284,9.16666667 L16.5981552,9.16666667 L16.2590747,7.5 L4.08575332,7.5 L3.74667284,9.16666667 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Sixtbook_Profile-A",
    transform: "translate(-1042.000000, -317.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contact-Info",
    transform: "translate(0.000000, 71.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "work-address",
    transform: "translate(1010.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_handbag",
    transform: "translate(31.534483, 194.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#ffffff",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoHandbag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_handbag.28f4c594dd92cddb5b140a90a32aa52f.svg";